const zh = {
  common: {
    lang: '语言',
    back: '返回',
    next: '下一步',
    submit: '提交',
  },
  homeIndex: {
    featureSearchAvailability: '搜索可用性',
    featureSchedule: '安排',
    featureConfirmationReceipt: '确认/收到',
    featureReschedule: '重新安排',
    featureCancel: '取消',
  },
  scheduleAppointment: {
    title: '考试预约',
    selectSponsorLabel: '选择一个考试主办方',
    selectSponsorPlaceHolder: '请选择一个考试主办方',
    selectProgramLabel: '选择 一个计划',
    selectProgramPlaceHolder: '请选择一个计划',
    selectRightSponsorLabel: '考试主办方：',
    selectRightProgramLabel: '计划名称：',
    selectRightQualificationLabel: '资格信息：',
    selectRightTestLabel: '考试名称：',
    agreementFirst:
      '我确认我在注册居所管辖区已达法定年龄，或我是数据主体和／或考生的家长或监护人，并获授权就个人数据的收集和处理，做出下列所需的同意与否的选择。',
    agreementSecond: '我同意我的个人数据被收集与处理，如本个人数据隐私披露与同意书所述。',
    agreementThird:
      '我同意将我的个人数据转移到我参加考试以外的国家/地区，如本个人数据隐私披露和同意表第 4 节所述，详细信息可查阅通过阅读隐私政策',
    agreementThirdHref: '通过阅读隐私政策。',
    agreementTips: '若您不同意我们收集、传输、处理、使用和储存您的个人数据，请与您的考试主办方联系。',
  },
  login: {
    title: '登录',
    or: '或',
    forgetPassword: '忘记密码？',
    password: '密码',
    phoneOrEmail: '手机号或邮箱',
    loginLoading: '登录中',
    scanSuccess: '扫码成功！',
    codeExpired: '该二维码已过期',
    retryText: '请重新获取',
    retry: '重新获取',
    scanWechat: '扫描关注微信公众号并登录',
    loginAccount: '帐号密码登录',
    firstLoginText: '首次登录系统，请使用账号密码登录',
    accountTip: '请填写账号',
    pwdTip: '请填写密码',
    pwdErrorTip: '密码错误，请检查账号或密码',
    accountNotExistTip: '用户不存在，请检查账号或密码',
  },
  privacyConfirm: {
    row_1: '个人数据隐私披露与同意',
    row_2: `Prometric（此后称为 "Prometric" 或 "我们" 或
    "我们的"）是您的考试主办方的数据处理者，考试主办方则是数据控制者。我们的主要办公室位于 1501 South Clinton
    Street，巴尔的摩，马里兰州 21224，美国。`,
    row_3: '1. 目的',
    row_4:
      '我们根据您的同意处理您的个人数据，用于为您注册并安排您参加考试、举办考试、防止欺诈，以及处理成绩的目的。在当地法律允许的情况下，我们也将根据我们的合法权益处理您的个人数据，以改善我们提供给您的考试主办方的防止欺诈服务与其他考试服务。关于我们的防止欺诈服务，这些流程使用专有算法来分析由录像视频所记取的元数据。为最大限度地减少所处理的个人数据，一旦录像记取了元数据，您的个人数据将被匿名化，以避免它与您的个人数据相关联。',
    row_5: `若没有通知您或未经您的许可，Prometric
      绝不会将您的个人数据用于任何其他目的。您的个人数据（包括您的考试成绩）都将提供给您的考试主办方，用于提供分数、认证或其他与考试相关服务的目的。完整的
      Prometric 隐私权政策（包括如何提交数据主体访问请求的指示）可在以下网址找到：`,
    row_6: '2. 使用录像与录音以监控考试的进行',
    row_7: `在以电脑操作的考试中心，Prometric
    将在所有考试交付地点采用数字录像（DVR）或闭路电视（CCTV）。在适用法律允许的情况下，这包括在接待处／储物柜、监考／安全登记过程中，以及考试实验室区进行的录音。为了保护高利害关系专项考试内容的安全性、考试交付体验的完整性，阻止欺诈和欺骗并防止盗窃和偷盗，以及保护职员与公司财产，这么做是必要的。录制的内容将严格限于授权人员接触，并按适用当地法律保留三十（30）天或更短时间。在一些情况下，如果需要用作合法证据，录制的内容将保留更长时间。`,
    row_8: `在我们的远程监考平台（ProProctor）上，Prometric
    收集由登记流程开始并于考试全程录制的录像视频，包括录音在内。有时，这将包括您的办公桌和工作区。我们将对您和您的工作区、办公桌以及您的工作区内的声音进行实时监控，并在考试进行期间记取与录下，以保护高利害关系专项考试内容的安全性、考试交付体验的完整性，以及阻止欺诈和欺骗。ProProctor
    的录音与录像将严格限于授权人员接触，并保留三十（30）天，或适用法律允许的期限（即合法证据）。`,
    row_9: `为确保您的考试的完整性，我们的远程监考平台（ProProctor）上的防止欺诈服务有可能会记取与您的特定考试相关的元数据，包括：IP地址、设备ID/电子序列号、地理位置、VPN
    状态、虚拟机的使用，或远程桌面协议软件。`,
    row_10: '3. 分享您的个人数据',
    row_11: `我们可能会雇用其他公司和个人代表我们履行职能。可查阅个人数据的我方员工、代理和承包商需按照 Prometric
    隐私权政策保护数据，对数据保密并维护数据主体的权利，而且我们要求第三方确保像 Prometric
    对其员工要求的那样保护隐私权，并遵守包括适用的数据保护法在内的相关规定。我们不会将个人数据传送给非经相应合约关系担任
    Prometric 代理或代表的第三方。`,
    row_12: `美国国内考生的个人数据将可以从美国访问，或者传输到美国进行处理和储存，国际考生的个人数据将按考生居住的国家所属区域进行处理，但公司位于世界其他地方的附属机构和数据处理者将可因为本声明首段所概述的目的所需而访问数据。"国际考生"
    指的是在美国境外永久居住且不持有美国护照的考生或员工。无论个人位置（最初收集或最终处理或存储该个人的数据的地方）在何处，Prometric
    将始终保护个人数据的隐私和安全。您申请和／或联系考试主办方以参加考试，通过 Prometric
    报名和安排考试时间，并在下方点击“我同意”予以同意，即表示授权我们向您（即数据主体和／或考生）收集个人数据并加以处理。`,
    row_13: '4. 数据传输',
    row_14: '考生个人数据将可因为第一节所概述的目的所需而从美国访问，或者传输到美国进行处理和储存。',
    row_15: `Prometric 遵循适用的当地数据保护法的要求来将数据传输给第三方国家。Prometric
    以由欧盟委员会批准的标准合约条款为依据，在我们位于欧洲的单位与我们位于世界其他地点的处理个人数据的单位之间，进行数据传输。我们也和我们的客户与服务提供者签订数据处理协议。`,
    row_16: '5. 您的权利',
    row_17: `按适用的当地法律，您可以要求访问、更正、清除、转移、限制，
    或反对处理您的个人数据，或向您当地的监管机构查询、提出请求、投诉，或在正常营业时间里联络您的考试主办方，以撤回与之相关的同意。您也可到`,
    row_18:
      '您若前往注册并安排考试时间，即准许我们收集并处理您的个人数据，如本个人数据隐私披露与同意书所述。您确认并同意我们在考试期间对您进行实时监控与录制。因此，请您将您的个人空间里的任何个人的照片或您或其他人的其他个人数据清除，以避免录像无意间记取到。',
  },
}
export default zh
